/**
 * Labels of the client's locations a subscription may be used at. `locationIds`
 * is tolerated as undefined because a stale or deploy-skewed subscription
 * response can omit it, and the card must not crash when it does.
 */
export function getUsableLocationLabels(
  locations: { locationId: number; label: string }[],
  locationIds: number[] | undefined,
): string[] {
  const usableIds = new Set(locationIds ?? []);
  return locations
    .filter((location) => usableIds.has(location.locationId))
    .map((location) => location.label);
}
